import React, { useEffect, useState } from 'react';
import {  useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import { CartUpdate } from "../services/CartUpdate";
import axios from 'axios';
import { Carousel } from "react-responsive-carousel";
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import ProductTiles from "../components/ProductTiles"
import Marquee from "react-fast-marquee";
import { AddBox, RemoveCircle, LocationOn, RemoveOutlined } from '@mui/icons-material';
import { Url } from '../services/Constants';
import { setHeader } from '../services/Headers';
import { GetUserRole } from '../services/UserRole';
import toast from 'react-hot-toast';

export default function Product() {

  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const userRole = GetUserRole();
  const Navigate = useNavigate()
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1)
  const [productCode,setProductCode] = useState();
  const [varientId, setVarientId] = useState()
  const [profile,setProfile] = useState()
  const [outofStock,setoutofstock] = useState(false)
  const [showImage,setShowImage] = useState()


  const addProduct = async (product) => {
    try {
        dispatch(addCart(product));
        // CartUpdate();
        toast.success("Product added to cart.")
    } catch (error) {
        console.error('Error adding product to cart:', error);
        toast.error("Error adding product to cart!")
    }
  };


  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        let response;
        if (userRole && userRole === "seller") {
          response = await axios.get(`${Url}/seller/products/${id}`, setHeader());
        }  else if (userRole === "buyer") {
          response = await axios.get(`${Url}/buyer/products/${id}`, setHeader());
        }else{
          response = await axios.get(`${Url}/buyer/products/${id}`);
        }
        const products = response.data.response_data
        setProduct(products);
        setShowImage(response.data.response_data.product_images[0].image)
        for (let i = 0; i < products.product_variants.length; i++) {
          const e = products.product_variants[i];
          if (e.left_qty !== 0) {
            setProductCode(e.product_code);
            setVarientId(e.id);
            break; 
          }
          else{
            setoutofstock(true)
          }
        }
        
      } catch (error) {
        console.error('Error fetching product details:', error);
      } finally {
        setLoading(false);
      }
    }
  

    fetchProductDetails();
  }, [id]);



  const deleteHandle = async()=>{
    try {
      const result = await axios.get(`${Url}/seller/get_profile`,setHeader())
      if(result.data.response_code ===200){
        const confirmed = window.confirm("Do yo want to delete product?")
        if(confirmed)
        {
          try {
            const deleteProduct = await axios.delete(`${Url}/seller/products/${id}`,setHeader())
            if(deleteProduct.data.response_code===200){
              toast.success("Product deleted successfully.")
              Navigate("/products")
            }
            else{
              toast.error("Something went wrong!")
            }
          } catch (error) {
            console.log(error)
          }
        }
      }

    } catch (error) {
      console.log(error)
    }
  }

  const addquantity = async() =>{
            setQuantity(quantity+1)
  }

  const removequantity = () =>{
    if(quantity>1){
      setQuantity(quantity-1)
    }
  }


  const addtoCart = async()=>{
    try {
      const result = await axios.get(`${Url}/buyer/products/check_available_quantity?product_variant_id=${varientId}&quantity=${quantity}`)
      if(result.data.response_code===200){
        const productData = product.product_variants.find(i=>i.id==varientId)
        try {
          const profile = await axios.get(`${Url}/buyer/get_profile`,setHeader())
          if(profile.data.response_code===200){
            try {
              const cartCreate = await axios.post(`${Url}/buyer/carts/add_to_cart?product_variant_id=${varientId}&quantity=${quantity}`,{},setHeader())
              if(cartCreate.data.response_code===200){
                try {
                  const getProduct = await axios.get(`${Url}/buyer/carts?page=1`,setHeader())
                  if(getProduct.data.response_code===200){
                    const preData = await  getProduct.data.response_data.carts.find(i=>i.product_variant_id==varientId)
                    const data = {...preData,quantity}
                    addProduct(data)
                  }
                  
                } catch (error) {
                  console.log(error)
                }
              }
            } catch (error) {
              console.log(error)
            }
          }else{
            const data = {
              cart_id:"",
              quantity:quantity,
              seller_name:product.seller_name,
              product_name:product.name,
              product_image:product.product_images[0].image,
              category:product.category_name,
              product_variant_id:Number(varientId),
              stock_qty:productData.stock_qty,
              left_qty:productData.left_qty,
              price:productData.price,
              discounted_price:productData.discounted_price,
              gst:productData.gst,
              product_code:product.category_id,
              isOutOfStock:""
            }
            addProduct(data)
          }
        } catch (error) {
          console.log(error)
        }
        
      }else{
        toast.error("Required quantity is not available!")
      }
    } catch (error) {
      console.log(error)
    }
  }

  const variantHandle = async(e)=>{
    const id = Number(e.target.id)
    try {
      const result = await axios.get(`${Url}/buyer/products/check_available_quantity?product_variant_id=${id}&quantity=1`)
      
      if(result.data.response_code!==200){
        setoutofstock(true)
      }
    } catch (error) {
      console.log(error)
    }
    setProductCode(e.target.innerText);
    setVarientId(e.target.id)
  }

  const showImageHandle = (e)=>{
    setShowImage(e.target.src)
  }

  // const buyNowHandle=async()=>{
  //   const productData = {...product,
  //     product_variant_id:varientId,
  //     quantity:quantity,
  //   }
  //   addProduct(productData)
  //   Navigate("/cart")
  // }


  const buyNowHandle = async()=>{
    try {
      const result = await axios.get(`${Url}/buyer/products/check_available_quantity?product_variant_id=${varientId}&quantity=${quantity}`)
      if(result.data.response_code===200){
        const productData = product.product_variants.find(i=>i.id==varientId)
        try {
          const profile = await axios.get(`${Url}/buyer/get_profile`,setHeader())
          if(profile.data.response_code===200){
            try {
              const cartCreate = await axios.post(`${Url}/buyer/carts/add_to_cart?product_variant_id=${varientId}&quantity=${quantity}`,{},setHeader())
              if(cartCreate.data.response_code===200){
                try {
                  const getProduct = await axios.get(`${Url}/buyer/carts?page=1`,setHeader())
                  if(getProduct.data.response_code===200){
                    const preData = await  getProduct.data.response_data.carts.find(i=>i.product_variant_id==varientId)
                    const data = {...preData,quantity}
                    await addProduct(data)
                    Navigate("/cart")
                  }
                  
                } catch (error) {
                  console.log(error)
                }
              }
            } catch (error) {
              console.log(error)
            }
          }else{
            toast.error("Please login!")
          }
        } catch (error) {
          console.log(error)
        }
        
      }else{
        toast.error("Required quantity is not available!")
      }
    } catch (error) {
      console.log(error)
    }    
  }




  return (
    <div className="product-container min-h-full bg-gray-50">
      <div className="product-top relative">
        <Navbar />
      </div>
      <div className="product-feed h-full mt-3 bg-gray-50 max-sm:mt-5 max-sm:mb-40  ">
        <div className="product-feed-container rounded-md bg-white w-[90%] flex gap-3 mx-auto p-4  md:w-[95%] max-sm:flex-col max-sm:pb-5 max-sm:p-0 ">
          <div className="product-feed-left flex fle[40%] md:w-1/2 max-sm:w-full max-sm:flex-col-reverse">
            <div className="thumbnails flex flex-col w-24 xl:h-[450px] mr-2 mx-auto overflow-y-auto lg:h-[380px] md:h-[350px] max-sm:flex-row max-sm:overflow-x-auto max-sm:w-[95%] max-sm:h-20 2xl:h-[550px]" style={{scrollbarWidth: "none", msOverflowStyle: "none" }}>
            {/* <div className=' flex flex-nowrap overflow-x-auto '> */}
            {product?.product_images.map((image, index) => ( 
              <>
              <div className='w-16 h-16 mx-auto max-sm:mr-2 mb-4 max-sm:my-2 max-sm:mx-0 max-sm:flex-shrink-0 '>
              <img key={index} src={image.image} alt={`product-img-${index}`} className='w-16 h-16 cursor-pointer object-cover rounded-sm  shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]' onClick={showImageHandle} /><hr className='h-[1px] mt-2 bg-gray-500 border-0 max-sm:hidden' />
              </div>
              {/* <div className='w-16 h-16 mx-auto max-sm:mr-2 mb-4 max-sm:my-2 max-sm:mx-0 max-sm:flex-shrink-0 '>
              <img key={index} src={image.image} alt={`product-img-${index}`} className='w-16 h-16 cursor-pointer object-cover rounded-sm  shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]' onClick={showImageHandle} /><hr className='h-[1px] mt-2 bg-gray-500 border-0 max-sm:hidden' />
              </div>
              <div className='w-16 h-16 mx-auto max-sm:mr-2 mb-4 max-sm:my-2 max-sm:mx-0 max-sm:flex-shrink-0 '>
              <img key={index} src={image.image} alt={`product-img-${index}`} className='w-16 h-16 cursor-pointer object-cover rounded-sm  shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]' onClick={showImageHandle} /><hr className='h-[1px] mt-2 bg-gray-500 border-0 max-sm:hidden' />
              </div>
              <div className='w-16 h-16 mx-auto max-sm:mr-2 mb-4 max-sm:my-2 max-sm:mx-0 max-sm:flex-shrink-0 '>
              <img key={index} src={image.image} alt={`product-img-${index}`} className='w-16 h-16 cursor-pointer object-cover rounded-sm  shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]' onClick={showImageHandle} /><hr className='h-[1px] mt-2 bg-gray-500 border-0 max-sm:hidden' />
              </div>
              <div className='w-16 h-16 mx-auto max-sm:mr-2 mb-4 max-sm:my-2 max-sm:mx-0 max-sm:flex-shrink-0 '>
              <img key={index} src={image.image} alt={`product-img-${index}`} className='w-16 h-16 cursor-pointer object-cover rounded-sm  shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]' onClick={showImageHandle} /><hr className='h-[1px] mt-2 bg-gray-500 border-0 max-sm:hidden' />
              </div>
              <div className='w-16 h-16 mx-auto max-sm:mr-2 mb-4 max-sm:my-2 max-sm:mx-0 max-sm:flex-shrink-0 '>
              <img key={index} src={image.image} alt={`product-img-${index}`} className='w-16 h-16 cursor-pointer object-cover rounded-sm  shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]' onClick={showImageHandle} /><hr className='h-[1px] mt-2 bg-gray-500 border-0 max-sm:hidden' />
              </div> */}
              
              </>
               ))}
               </div>
               <div className="image-div w-[95%] max-sm:w-[95%] max-sm:mx-auto">
                <img src={showImage} alt="product/image" className="rounded-sm object-scale-down xl:h-[450px] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] w-[95%] mx-auto lg:h-[380px] md:h-[350px] max-lg:w-full max-sm:w-full max-sm:h-[250px] 2xl:h-[550px]" />
               </div>
          </div>
            {/* {product?.product_images.map((image, index) => ( <img key={index} src={image.image} className='h-96 ' alt={`product-img-${index}`} />))} */}
          <div className="product-feed-right w-[80%] px-5 md:w-1/2 lg:px-2 md:px-0 max-sm:w-full max-sm:p-0 ">
            <div className="product-name mb-4 ">
              <span className='text-amber-950 text-2xl font-medium'>{product?.name}</span><span className="k">{" "}{`(${productCode})`}</span>
            </div>
            <div className="product-category mb-4">
              <span className=' text-amber-950'>Category:</span><span className=" ml-2">{product?.category_name}</span>
            </div>
            <div className="product-description mb-4">
              <span className=''>{product?.specification}{"A drill is a tool used to make holes in materials like wood, metal, and plastic. Drills are typically powered by electricity or a battery and have a rotating bit. They are commonly used in construction, carpentry, plumbing, and electrical work. "}</span>
            </div>
            <div className="product-price mb-4">
              <span className='font-bold text-xl'>Rs. {product?.product_variants[0].discounted_price}</span>
              <span className="line-through text-gray-500 ml-4 ">Rs. {product?.product_variants[0].price}</span>
              {/* <span className="font-bold text-amber-950 ml-2">{`(${(((product?.product_variants[0].price - product?.product_variants[0].discounted_price) / product?.product_variants[0].price) * 100).toFixed(2)} % Off)`}</span> */}
              <div className="gst">
              <span className=" text-xs">GST:-</span>
              <span className="ml-1 text-xs">{product?.product_variants[0].gst}%</span>
              </div>
            </div>
            <div className="product-qty mb-4 flex items-center">
              {/* <span className="text-amber-950 cursor-default font-bold">Quantity:</span> */}
              <div className="right cursor-pointer flex justify-center items-center  " onClick={removequantity}>
                <span className='text-2xl bg-red-50 px-2 rounded-sm'>-</span></div>
              <div className="center px-2 ml-3 py-0 cursor-default">{quantity}</div>
              <div className="left ml-2 cursor-pointer flex justify-center " onClick={addquantity}>
                <span className='text-xl bg-red-50 px-2 pb-1 rounded-sm'>+</span></div>
            </div>
            <div className="product-variants mb-4">
              <span className=" font-bold text-amber-950 cursor-default ">Varients:</span>
              {product?.product_variants.length>0?product.product_variants.map((variant) => (
                  <span
                    key={variant.id} id={variant.id}
                    className="ml-3 bg-red-50 p-1 text-sm font-bold rounded-xl cursor-pointer" onClick={variantHandle}
                  >
                    {variant.product_code}
                  </span>
                )):""}

              
              {/* {product?.is_variant ? (
                product?.product_variants.map((variant) => (
                  <span
                    key={variant.id}
                    className="ml-3 bg-gray-400 text-amber-950 p-1 text-sm rounded-xl cursor-pointer hover:bg-gray-600"
                  >
                    {variant.size}
                  </span>
                ))
              ) : (
                <span className="ml-3 bg-gray-400 text-amber-950 p-1 text-sm rounded-xl">
                  0
                </span>
              )} */}



            </div>
            <div className="product-variants mb-4">
              <span className=" font-bold text-amber-950 cursor-default ">Product quantity:</span>
              {product?.product_variants.length>0?product.product_variants.map((variant) => (
                  <span
                    key={variant.id} id={variant.id}
                    className="ml-3 bg-red-50 p-1 text-sm font-bold rounded-xl cursor-pointer"
                  >
                    {variant.left_qty}
                  </span>
                )):""}
            </div>
            <div className="product-btns flex mb-4">
            {GetUserRole()==="seller"?"":
            <>{!outofStock?<><div className="add-cart bg-white w-28 px-2 text-amber-950 border border-black h-12 flex items-center justify-center rounded-sm font-bold text-center cursor-pointer hover:text-white hover:bg-amber-950" onClick={addtoCart}>Add to Cart</div>
            <div className="buy-now text-amber-950 ml-5 w-28 bg-white h-12 flex border border-black items-center justify-center rounded-sm font-bold text-center cursor-pointer hover:text-white hover:bg-amber-950" onClick={buyNowHandle}>Buy Now</div></>: <div className=" text-red-700 text-3xl">Out of stock</div> }</>}
            </div>
            {GetUserRole()!=="seller"?<div className="product-location flex items-end cursor-pointer">
              <span className="k">{product?.seller_name?product.seller_name:""}</span>
              <span className="ml-1 text-amber-950 font-bold hover:underline">{product?.seller_city?product.seller_city:""}, {product?.seller_state?product.seller_state:""}</span>
            </div>:<div className='flex justify-end'>
              <img src="../assets/editing.png" alt="" className='h-5 w-5 cursor-pointer ' onClick={()=>{Navigate(`/update-product/${product.id}`)}} />
              <img src="../assets/delete.png" alt="" className='h-5 w-5 ml-3 cursor-pointer' onClick={deleteHandle}/>
              </div>}
          </div>
        </div>
        {/* <div className="product-feed-center mt-24 px-4 md:px-16">
          {userRole!=="seller"?<>
            <div className="center-title text-amber-950 font-bold text-2xl border-b-2 border-b-amber-950">
              Similar Products
            </div>
            <div className="similar-products my-5 mx-3">
              <ProductTiles />
            </div>
          </>:""}
        </div> */}
      </div>
      <div className="product-bottom relative w-full bottom-0">
        <Footer />
      </div>
    </div>
  )
}
